import { ChevronRight, Mail, Network, UserPlus } from 'lucide-react';
import { useNavigate } from '@tanstack/react-router';

import { Button } from '@/components/ui/button';

export const NoAccessAccountGroup = () => {
  const navigate = useNavigate();
  return (
    <div className="pb-6">
      <div className="grid min-h-full place-items-center rounded-xl border bg-white px-6 py-24 sm:py-10 lg:px-28">
        <div className="">
          <div className="flex flex-col items-center">
            <div className="flex h-14 w-14 items-center justify-center rounded-md bg-[#EBF2FF]">
              <Network className="text-brand-blue h-8 w-8" />
            </div>
            <h3 className="mt-4 text-2xl font-medium tracking-tight text-gray-900 sm:text-2xl">
              Account Groups
            </h3>
          </div>
          <p className="mt-4 text-sm leading-6 font-light text-gray-600">
            Manage multiple businesses under one parent account. If your company operates several
            Doitpay businesses, an Account Group gives the parent's superadmin a consolidated view
            of transactions, merchants, and users across every sub-business.
          </p>

          <div className="border-brand-blue mt-6 mb-6 rounded-md border bg-[#EBF2FF] p-5">
            <h6 className="text-brand-blue text-sm uppercase">How To Activate</h6>
            <p className="mt-2 text-sm font-light">
              Account Groups are set up by Doitpay during onboarding. If your company manages more
              than one business and you'd like a consolidated view, contact your account manager or
              email{' '}
              <a href="mailto:hello@doitpay.co" className="underline">
                hello@doitpay.co
              </a>
            </p>
            <a href="mailto:hello@doitpay.co">
              <Button className="mt-2.5 text-xs">
                <Mail />
                Contact Account Manager
              </Button>
            </a>
          </div>
          <div className="mb-6 border-t" />
          <div className="flex flex-col items-center">
            <h6 className="text-sm text-[#737373] uppercase">Looking for something else?</h6>
            <div
              onClick={() =>
                navigate({
                  to: '/business-profile',
                })
              }
              className="mt-5 flex w-full cursor-pointer items-center justify-between rounded-md border p-4"
            >
              <div className="flex items-center gap-3">
                <div className="flex h-8 w-8 items-center justify-center rounded border border-[#E5E5E5] bg-[#FAFAFA]">
                  <UserPlus className="h-4 w-4 text-[#525252]" />
                </div>
                <div className="">
                  <h6 className="text-base">Invite a teamate</h6>
                  <div className="flex items-center gap-2">
                    <span className="text-xs font-light">Business profile</span>
                    <ChevronRight className="h-4 w-4" />
                    <span className="text-xs font-light">Add Users</span>
                  </div>
                </div>
              </div>
              <ChevronRight className="h-5 w-5 text-[#525252]" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
